import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import {
  FlexColCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';

interface Props {
  name: string;
  theme: any;
  url: string;
  img: string;
  lastParent: any;
}

function CategoryCard({ name, theme, url, img, lastParent }: Props) {
  const getName = (catName: string): string => {
    const maxLength = 50;
    if (catName.length > maxLength) {
      return catName.substring(0, maxLength) + '...';
    }
    return catName.substring(0, maxLength);
  };

  return (
    <Wrapper title={name} to={url}>
      <BottomBorder />
      <RightBorder />
      <Image alt={`Obrázok kategórie ${name}`} src={img} />
      <CategoryName>
        {lastParent ? `...  / ${lastParent.category_name}  /  ` : ''}
        {getName(name)}
      </CategoryName>
    </Wrapper>
  );
}

const BottomBorder = styled.div`
  border-top: ${({ theme }) => theme.borders.productList};
  position: absolute;
  left: ${rem(0)};
  right: ${rem(0)};
  bottom: 0;

  ${({ theme }) => theme.mediab.s450`
    left: ${rem(0)};
    right: ${rem(0)};
  `}
`;

const RightBorder = styled.div`
  border-right: ${({ theme }) => theme.borders.productList};
  position: absolute;
  bottom: ${rem(0)};
  top: ${rem(0)};
  right: 0;

  ${({ theme }) => theme.mediab.s450`
    bottom: ${rem(0)};
    top: ${rem(0)};
  `}
`;

const Wrapper = styled(Link)`
  height: ${rem(72)};
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  text-decoration: none;
  &:nth-child(3n) > :nth-child(2) {
    border: 0;
  }

  &:nth-child(3n + 1):nth-last-child(-n + 3),
  &:nth-child(3n + 1):nth-last-child(-n + 3) ~ & {
    ${BottomBorder} {
      display: none;
    }
  }
  ${({ theme }) => theme.mediab.l1400`
    &:nth-child(3n) > :nth-child(2) {
      border-right: ${theme.borders.productList};
    }
    &:nth-child(even) > :nth-child(2) {
      border: 0;
    }


    &:nth-child(3n + 1):nth-last-child(-n + 3),
    &:nth-child(3n + 1):nth-last-child(-n + 3) ~ & {
      ${BottomBorder} {
        display: inline;
      }
    }

    &:nth-child(2n + 1):nth-last-child(-n + 2),
    &:nth-child(2n + 1):nth-last-child(-n + 2) ~ & {
      ${BottomBorder} {
        display: none;
      }
    }
  `}
  ${({ theme }) => theme.mediab.l1050`
      &:nth-child(odd) > :nth-child(2) {
        border-right: 0;
      }
  `}
`;

const Image = styled.img`
  width: ${rem(54)};
  height: ${rem(54)};
  margin: ${rem(8)} ${rem(16)};
  min-width: ${rem(56)};
  cursor: pointer;
`;

const CategoryName = styled.div`
  font-size: ${rem(16)};
  line-height: ${rem(18)};
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  color: #003463;
  text-align: left;
  text-decoration: none;
  margin: ${rem(8)} ${rem(8)};
  padding-right: ${rem(8)};
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;

  &:hover {
    text-decoration: underline;
  }
`;

const WithTheme: any = withTheme(CategoryCard);
export { WithTheme as SanitasCategoryCard };
